(() => {
  const drawerClass = 'asrumo-size-chart-drawer';
  const styleId = 'asrumo-size-chart-drawer-styles';
  if (document.getElementById(styleId)) return;

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    .scr-modal.${drawerClass} {
      --size-chart-ink: rgb(var(--text-color, 127 100 82));
      --size-chart-line: #ece8e5;
      --size-chart-soft: #f7f4f1;
      box-sizing: border-box !important;
      position: fixed !important;
      inset: 0 0 0 auto !important;
      width: min(100vw, 500px) !important;
      max-width: none !important;
      height: 100vh !important;
      height: 100dvh !important;
      max-height: none !important;
      padding: 0 28px 28px !important;
      overflow: auto !important;
      overscroll-behavior: contain;
      background: #fff !important;
      color: var(--size-chart-ink) !important;
      font-family: var(--text-font-family, Montserrat, sans-serif) !important;
      font-size: 13px !important;
      line-height: 1.6;
      letter-spacing: normal !important;
      box-shadow: -8px 0 36px rgb(127 100 82 / 9%) !important;
      transform: translateX(100%) !important;
      transition: transform 280ms ease, opacity 200ms ease, visibility 200ms ease !important;
    }

    .scr-modal.${drawerClass}[style*="visibility: visible"] {
      transform: translateX(0) !important;
    }

    .scr-modal.${drawerClass} .asrumo-size-chart-drawer__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      min-height: 84px;
      border-bottom: 1px solid var(--size-chart-line);
      margin-bottom: 22px;
      background: #fff;
    }

    .scr-modal.${drawerClass} .asrumo-size-chart-drawer__heading {
      margin: 0 !important;
      padding: 0 !important;
      color: var(--size-chart-ink) !important;
      font-family: inherit !important;
      font-size: 20px !important;
      font-weight: 500 !important;
      line-height: 1.3 !important;
      text-align: left !important;
      text-transform: none !important;
      letter-spacing: -0.3px !important;
    }

    .scr-modal.${drawerClass} .scr-close {
      position: relative !important;
      inset: auto !important;
      display: block !important;
      flex: 0 0 44px;
      width: 44px !important;
      height: 44px !important;
      min-width: 44px;
      min-height: 44px;
      float: none !important;
      margin: 0 -10px 0 0 !important;
      padding: 0 !important;
      border: 0 !important;
      background: transparent !important;
      color: var(--size-chart-ink) !important;
      opacity: 1 !important;
      cursor: pointer;
    }

    .scr-modal.${drawerClass} .scr-close::before,
    .scr-modal.${drawerClass} .scr-close::after {
      content: '' !important;
      position: absolute !important;
      top: 21px !important;
      left: 13px !important;
      width: 18px !important;
      height: 1.5px !important;
      background: currentColor !important;
      transform: rotate(45deg) !important;
    }

    .scr-modal.${drawerClass} .scr-close::after {
      transform: rotate(-45deg) !important;
    }

    .scr-modal.${drawerClass} .scr-close:hover {
      background: var(--size-chart-soft) !important;
      border-radius: 50%;
    }

    .scr-modal.${drawerClass} .scr-close:focus-visible {
      outline: 2px solid var(--size-chart-ink);
      outline-offset: 2px;
      border-radius: 50%;
    }

    .scr-modal.${drawerClass} .asrumo-size-chart-drawer__notice {
      margin: 0 0 24px !important;
      padding: 12px 14px !important;
      border: 1px solid var(--size-chart-line) !important;
      border-left: 3px solid var(--size-chart-ink) !important;
      border-radius: 4px;
      background: var(--size-chart-soft) !important;
      color: var(--size-chart-ink) !important;
      font-family: inherit !important;
      font-size: 12px !important;
      font-weight: 500 !important;
      line-height: 1.7 !important;
      letter-spacing: normal !important;
      text-align: left !important;
    }

    .scr-modal.${drawerClass} .scr {
      margin: 0 !important;
      padding: 0 !important;
      overflow-x: auto;
      border: 1px solid var(--size-chart-line);
      border-radius: 6px;
      background: #fff;
      font-family: inherit !important;
      overscroll-behavior-inline: contain;
    }

    .scr-modal.${drawerClass} .scr table.scr-table {
      border-collapse: collapse !important;
      border-spacing: 0 !important;
      table-layout: fixed !important;
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
      margin: 0 !important;
      border: 0 !important;
      background: #fff !important;
      font-family: inherit !important;
      box-shadow: none !important;
    }

    /* Override the app and theme row rules, including their !important stripes. */
    .scr-modal.${drawerClass} .scr table.scr-table tr,
    .scr-modal.${drawerClass} .scr table.scr-table tr > :is(th, td) {
      background: #fff !important;
      background-image: none !important;
      color: var(--size-chart-ink) !important;
      box-shadow: none !important;
    }

    .scr-modal.${drawerClass} .scr table.scr-table tr > :is(th, td) {
      box-sizing: border-box !important;
      width: auto !important;
      min-width: 0 !important;
      max-width: none !important;
      height: 44px !important;
      padding: 11px 6px !important;
      border: 0 !important;
      border-bottom: 1px solid var(--size-chart-line) !important;
      font-family: inherit !important;
      font-size: 13px !important;
      font-weight: 400 !important;
      font-variant-numeric: tabular-nums;
      line-height: 1.5 !important;
      text-align: center !important;
      text-transform: none !important;
      letter-spacing: normal !important;
      white-space: normal !important;
      word-break: normal !important;
      overflow-wrap: normal !important;
    }

    .scr-modal.${drawerClass} .scr table.scr-table tr:nth-child(2n + 3) > td {
      background: #fcfbfa !important;
    }

    .scr-modal.${drawerClass} .scr table.scr-table tr:first-child > th {
      background: var(--size-chart-soft) !important;
      font-size: 11px !important;
      font-weight: 600 !important;
    }

    .scr-modal.${drawerClass} .scr table.scr-table tr > :first-child {
      font-weight: 600 !important;
    }

    .scr-modal.${drawerClass} .scr table.scr-table tr:last-child > td {
      border-bottom: 0 !important;
    }

    .scr-shadow {
      background: rgb(127 100 82 / 16%) !important;
    }

    @media screen and (max-width: 699px) {
      .scr-modal.${drawerClass} {
        width: 100vw !important;
        padding: 0 18px max(24px, env(safe-area-inset-bottom)) !important;
      }

      .scr-modal.${drawerClass} .asrumo-size-chart-drawer__header {
        min-height: 74px;
        margin-bottom: 18px;
      }

      .scr-modal.${drawerClass} .asrumo-size-chart-drawer__heading {
        font-size: 18px !important;
      }

      .scr-modal.${drawerClass} .asrumo-size-chart-drawer__notice {
        margin-bottom: 20px !important;
      }

      .scr-modal.${drawerClass} .scr table.scr-table tr > :is(th, td) {
        font-size: 12px !important;
        padding: 10px 3px !important;
        height: 42px !important;
      }

      .scr-modal.${drawerClass} .scr table.scr-table tr:first-child > th {
        font-size: 10px !important;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .scr-modal.${drawerClass} { transition: none !important; }
    }
  `;
  document.head.appendChild(style);

  function decorate(modal) {
    modal.querySelectorAll('.scr table tr:not(:first-child)').forEach((row) => {
      const cell = row.cells[0];
      const label = cell?.textContent.trim();
      if (/^X{2,}L$/i.test(label || '')) {
        cell.textContent = (label.length - 1) + 'xl';
      }
    });
    if (modal.dataset.asrumoSizeChartDrawer === 'true') return;
    const chart = modal.querySelector('.scr');
    const close = modal.querySelector('.scr-close');
    if (!chart || !close) return;

    modal.dataset.asrumoSizeChartDrawer = 'true';
    modal.classList.add(drawerClass);
    modal.setAttribute('aria-label', 'Size chart');
    const heading = chart.querySelector('h2') || document.createElement('h2');
    if (!heading.textContent.trim()) heading.textContent = 'Size Chart';
    heading.classList.add('asrumo-size-chart-drawer__heading');
    const header = document.createElement('div');
    header.className = 'asrumo-size-chart-drawer__header';
    header.append(heading, close);
    modal.prepend(header);

    const notice = document.createElement('p');
    notice.className = 'asrumo-size-chart-drawer__notice';
    notice.textContent = 'This size chart is based on body measurements.';
    modal.insertBefore(notice, chart);
  }

  document.querySelectorAll('.scr-modal').forEach(decorate);
  new MutationObserver((records) => {
    for (const record of records) {
      const modal = record.target.closest?.('.scr-modal');
      if (modal) decorate(modal);
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('.scr-modal')) decorate(node);
        node.querySelectorAll('.scr-modal').forEach(decorate);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
